
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import Prism from 'vue-prism-component';

    // DIY shared state ^^
    let selectedLanguage = localStorage.getItem('selected-language');
    if (!selectedLanguage) {
        selectedLanguage = 'js';
    }
    if (selectedLanguage !== 'js' && selectedLanguage !== 'php') {
        selectedLanguage = 'js';
    }
    const state = {
        selected: selectedLanguage,
    };

    @Component({
        components: {
            Prism,
        }
    })
    export default class Extract extends Vue {
        @Prop() private file!: string;
        @Prop() private isConfig!: boolean;
        state = state;
        contentJS = '';
        contentPHP = '';
        contentConfigJS = '';
        contentConfigPHP = '';

        created() {
            if (!this.isConfig) {
                this.axios.get(`samples/${this.file}.js`).then((data) => {
                    this.contentJS = data.data;
                });
                this.axios.get(`samples/${this.file}.php`).then((data) => {
                    this.contentPHP = data.data;
                });
            } else {
                this.axios.get(`samples/${this.file}-js.yml`).then((data) => {
                    this.contentConfigJS = data.data;
                });
                this.axios.get(`samples/${this.file}-php.yml`).then((data) => {
                    this.contentConfigPHP = data.data;
                });
            }
        }

        @Watch('state', {
            deep: true
        })
        storeState() {
            localStorage.setItem('selected-language', this.state.selected);
        }
    }
